export const locale = {
  lang: 'en-CA',
  data: {
    UPGRADE_REQUEST: {
      TITLE: 'Request an upgrade',
      INTRO:
        'Tell us what you are interested in and leave us a message: our team will contact you to move to the PRO plan.',
      INTERESTED_IN: 'We are interested in:',
      INTEREST_SUBMISSIONS: 'Web Submissions',
      INTEREST_AUTOMATIONS: 'Automations',
      INTEREST_INTEGRATIONS: 'Integrations',
      MESSAGE: 'Message',
      MESSAGE_PLACEHOLDER:
        'Your needs, your questions, the best time to reach you…',
      SEND: 'Send',
      SENT_TOAST: 'Request sent. Thank you!',
      SENT_TITLE: 'Request sent',
      SENT_TEXT:
        'Thank you! Our team has received your request and will contact you shortly.',
      SEND_ANOTHER: 'Send another request',
    },
  },
};
